module.exports = __webpack_public_path__ + "img/p3.cb834d6d.png";